<script lang="ts">
    import {MaterialIcon} from "@ac/material-icons/src";
    import {AcDropdown, AcDropdownItem} from "ACUi/acui-dropdown";
    import {calculateColumn} from "../ajax/calculate";
    import {MetricTypes} from "../index";
    import {AcLoading} from "ACUi/element";
    import {getMetricConfig} from "../utils/inline-var";

    export let column: string;

    const config = getMetricConfig();

    let loading: boolean = false;
    let result: string | null = null;
    let calculationType: MetricTypes;

    const calculate = (e: CustomEvent<MetricTypes>) => {
        calculationType = e.detail;
        loading = true;

        calculateColumn(column, e.detail).then(r => {
            result = r.data;
        }).finally(() => {
            loading = false;
        });
    }

    const getMetricLabel = (metric: MetricTypes) => {
        return config.metrics[metric] || metric;
	}

</script>


<AcDropdown appendToBody>
		<span slot="trigger"
			class="acp-metric-badge acu-cursor-pointer acu-flex acu-place-items-center acu-gap-1 acu-relative">
			{#if !result && !loading }
				<MaterialIcon icon="functions"/> Calculate
			{:else if loading}
				<AcLoading size="small"/>
			{:else}
				<span class="acp-metric-badge__type acu-uppercase">{getMetricLabel(calculationType)}</span>
				<span class="acp-metric-badge__result acu-font-bold">{result}</span>
			{/if}
		</span>
	{#each Object.entries(config.metrics) as [key, label]}
		<AcDropdownItem on:click={calculate} value={key}>
			{label}
		</AcDropdownItem>
	{/each}
</AcDropdown>
